import styled from 'styled-components';
import { palette } from 'styled-tools';

import {
	fontFamily,
	FontSizes,
	FontWeights,
	minWidth,
	Text,
	TextElements,
	units,
} from '@calm-web/design-system';

export const StyledButton = styled.button`
	border: none;
	background: none;
	${fontFamily};
	display: flex;
`;

export const ButtonContainer = styled.div`
	margin: 0 auto ${units(4)};
	width: 236px;
	text-align: center;
	cursor: pointer;

	${minWidth('desktop')} {
		margin: 0;
	}
`;

export const BubbleWrap = styled.div`
	display: flex;
	-webkit-box-pack: center;
	justify-content: center;
	margin-bottom: 28px;
`;

export const IconHolder = styled.div<{ backgroundColor: string }>`
	width: 100px;
	height: 100px;
	border-radius: 50px;
	position: relative;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-pack: center;
	justify-content: center;
	-ms-flex-align: center;
	align-items: center;
	margin: 0 20px;
	background: ${p => palette(p.backgroundColor || 'gray7')};
`;

export const Header = styled(Text).attrs({
	el: TextElements.H4,
	size: FontSizes.xl,
	weight: FontWeights.Medium,
})`
	line-height: ${units(4.5)};
	margin-bottom: 4px;
`;

export const Subtitle = styled(Text).attrs({
	el: TextElements.P,
	size: FontSizes.base,
	weight: FontWeights.Light,
})``;
